import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios, { AxiosHeaders, type InternalAxiosRequestConfig } from 'axios'
import { QUERY_KEY_JOBS_VIEWS } from './useApiMenuGetAllJobsViews'
import { toast } from 'react-toastify'
import type { NavigationMenuIdentity } from '../../../components/common/mygame/menu/menu-interface'
import { useTranslation } from 'react-i18next'

export const useApiMenuPostJobsViews = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (params: NavigationMenuIdentity) => {
      const url = '/navigation_menu'
      const config: InternalAxiosRequestConfig = {
        method: 'post',
        url,
        data: { ...params },
        headers: new AxiosHeaders()
      }
      return axios(config)
    },
    onSuccess: () => {
      toast.info(t('menu.alert.save'))
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEY_JOBS_VIEWS] })
    },
    onError: () => {
      toast.error(t('error.description'))
    }
  })
}
